document.addEventListener('touchstart', handleTouchStart, false);
document.addEventListener('touchmove', handleTouchMove, false);
document.addEventListener('touchend', handleTouchEnd, false);

var firstXDown = null;
var firstYDown = null;

var prevXDown = null;
var prevYDown = null;

var moveXDown = null;
var moveYDown = null;

function getTouches(evt) {
    return evt.touches ||             // browser API
        evt.originalEvent.touches; // jQuery
}

function handleTouchStart(evt) {
    const firstTouch = getTouches(evt)[0];
    firstXDown = firstTouch.clientX;
    firstYDown = firstTouch.clientY;
};

function handleTouchMove(evt) {
    const moveTouch = getTouches(evt)[0];

    prevXDown = moveXDown;
    prevYDown = moveYDown;

    moveXDown = moveTouch.clientX;
    moveYDown = moveTouch.clientY;

    var xDiff = moveXDown - firstXDown;
    var yDiff = moveYDown - firstYDown;
    evt.target.dispatchEvent(new CustomEvent("tf.swipe.moving", { bubbles: true, cancelable: false, detail: { yDiff: yDiff, xDiff: xDiff } }));
}

function handleTouchEnd(evt) {
    if (!prevXDown || !prevYDown || !moveXDown || !moveYDown) {
        return;
    }

    evt.target.dispatchEvent(new CustomEvent("tf.swipe.ended", { bubbles: true, cancelable: false }));

    var xDiff = moveXDown - prevXDown;
    var yDiff = moveYDown - prevYDown;

    if (Math.abs(xDiff) > Math.abs(yDiff)) {
        if (xDiff > 0) {            
            evt.target.dispatchEvent(new CustomEvent("tf.swipe.right", {bubbles: true, cancelable: false}));
        } else {            
            evt.target.dispatchEvent(new CustomEvent("tf.swipe.left", { bubbles: true, cancelable: false }));
        }
    } else {
        if (yDiff > 0) {            
            evt.target.dispatchEvent(new CustomEvent("tf.swipe.down", { bubbles: true, cancelable: false }));
        } else {            
            evt.target.dispatchEvent(new CustomEvent("tf.swipe.up", { bubbles: true, cancelable: false }));
        }
    }
    /* reset values */
    firstXDown = null;
    firstYDown = null;
    moveXDown = null;
    moveYDown = null;
    prevXDown = null;
    prevYDown = null;
};